/**
 * el-drawer抽屉页做左右拖拽
 */

const drag = {
  inserted: function(el, binding) {
    const minWidth = 1200
    const dragDom = el.querySelector('.el-drawer')
    // const dragDom1 = el.querySelector('.el-drawer__container')
    // const dragDom2 = el.querySelector('.el-drawer__wrapper')
    dragDom.style.overflow = 'auto'

    const resizeElL = document.createElement('div')
    const img = new Image(24, 38)
    dragDom.appendChild(resizeElL)
    resizeElL.style.cursor = 'w-resize'
    resizeElL.style.position = 'absolute'
    resizeElL.style.height = '100%'
    resizeElL.style.width = '30px'
    resizeElL.style.left = '0px'
    resizeElL.style.top = '0px'
    img.style.position = 'absolute'
    img.style.left = '-12px'
    img.style.top = '50%'

    resizeElL.onmousedown = (e) => {
      const elW = dragDom.clientWidth
      const EloffsetLeft = dragDom.offsetLeft
      //   console.log(elW, EloffsetLeft)
      const clientX = e.clientX
      document.onmousemove = function(e) {
        e.preventDefault()
        // 左侧鼠标拖拽位置
        if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
          // 往左拖拽
          if (clientX > e.clientX) {
            // console.log(e.clientX)
            dragDom.style.width = elW + (clientX - e.clientX) + 'px'
            // console.log('向左拖拽', dragDom.style.width)
          }
          // 往右拖拽
          //   console.log('打印坐标', clientX, e.clientX)
          if (clientX < e.clientX) {
            // console.log('向右拖拽', dragDom.style.width)
            if (dragDom.clientWidth >= minWidth) {
            //   console.log(elW, e.clientX, clientX)
              dragDom.style.width = elW - (e.clientX - clientX) + 'px'
            }
          }
        }
      }
      // 拉伸结束
      document.onmouseup = function(e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}

export default drag
